import httpClient from '@/lib/httpClient'
import useAuthStore from '@/store/useAuthStore'
import { useMutation } from '@tanstack/react-query'

/**
 * Sign in / sign up with Xero (identity scopes only, all plans).
 *
 * The API binds the OAuth state to the current session, so the session cookie
 * must exist before /authorize and must not be replaced (no logout) before the
 * callback posts back — unlike the Google/Facebook flow in useLogin.
 */
export function useStartXeroSignIn() {
  const mutation = useMutation({
    mutationFn: async () => {
      await httpClient.get('/csrf-cookie')
      const response = await httpClient.get('auth/xero/authorize')
      return response.data.authorize_url as string
    },
    onSuccess: (url) => window.location.assign(url),
  })

  return { action: mutation.mutateAsync, status: mutation }
}

export function useCompleteXeroSignIn() {
  const authenticate = useAuthStore((state) => state.authenticate)

  const mutation = useMutation({
    mutationFn: async ({ code, state }: { code: string; state: string }) => {
      const response = await httpClient.post('auth/xero/sign-in', {
        code,
        state,
      })
      return response
    },
    onSuccess: () => authenticate(true),
  })

  return { action: mutation.mutateAsync, status: mutation }
}
